export default {

  // "production": "http://119.254.234.92:10095/reception-service/", // 生产环境
  // "development": "http://10.223.225.2:81/reception-service/", // 打包测试环境
  // "development": "http://172.24.114.199:81/reception-service/", // 开发环境

  // baseURL: "/test_url",// 添加的请求前缀

  // 请求头
  "headers": {
    // "Content-Type": "application/x-www-form-urlencoded"
    "Content-Type": "application/json",
    "charset": "utf-8",
  },
  timeout: 10000, // 请求超时时间，单位毫秒
  // axios 支持的其他不常用配置
  "other": {},
}